import { AppBar, IconButton, Tabs, Toolbar, useTheme } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded'
import { RouteConstants } from '../navigation/navigation-types'
import { openDialog } from '../services/redux/savestate/savestate-actions'
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks'
import { getSaveState } from '../services/redux/savestate/savestate-selectors'
import NavbarCustomTab from './NavbarCustomTab'
import { getAuthState } from '../services/redux/auth/auth-selectors'
import { UserRole } from '../services/api/sharedTypes/User'

const Navbar: React.FC = () => {
    /**
     * selectedTabValue is used to determine which tab is selected
     * 0 = Dashboard
     * 1 = Klienti
     * 2 = Události
     * 3 = Atrakce a služby
     * 4 = Brigádníci a dopravci
     * 5 = Statistiky
     * 6 = Faktury
     * 7 = Emaily a dotazníky
     * 8 = Administrace
     * false = none
     */
    const [selectedTabValue, setSelectedTabValue] = React.useState<number | false>(0)

    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const theme = useTheme()
    const { role: userRole } = useAppSelector(getAuthState)

    const isAdmin = userRole === UserRole.Admin

    const saveState = useAppSelector(getSaveState)

    React.useEffect(() => {
        if (location.pathname.includes('settings')) {
            setSelectedTabValue(false)
        } else if (location.pathname.includes('clients')) {
            setSelectedTabValue(1)
        } else if (location.pathname.includes('events')) {
            setSelectedTabValue(2)
        } else if (location.pathname.includes('product')) {
            setSelectedTabValue(3)
        } else if (location.pathname.includes('workersAndCarriers')) {
            setSelectedTabValue(4)
        } else if (location.pathname.includes('statistics')) {
            setSelectedTabValue(5)
        } else if (location.pathname.includes('invoices')) {
            setSelectedTabValue(6)
        } else if (location.pathname.includes('emailsAndSurveys')) {
            setSelectedTabValue(7)
        } else if (location.pathname.includes('administration')) {
            setSelectedTabValue(8)
        }
        else {
            setSelectedTabValue(0)
        }
    }, [location])

    const handleNavigation = (route: RouteConstants) => {
        saveState ? navigate(route) : dispatch(openDialog(route))
    }

    const onLogoClick = () => {
        if (isAdmin) {
            handleNavigation(RouteConstants.home)
        }
    }

    return (
        <AppBar
            position='relative'
            color='inherit'
            style={{ height: 56, boxShadow: 'none', paddingLeft: theme.spacing(2), paddingRight: theme.spacing(2) }}
        >
            <Toolbar>
                <div onClick={onLogoClick} style={{ width: '42px', cursor: 'pointer' }}>
                    <img
                        src='https://happytimes.cz/wp-content/uploads/logo-2.png'
                        alt='Happytimes logo'
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>

                <Tabs
                    style={{ margin: 'auto' }}
                    value={selectedTabValue}
                    variant='scrollable'
                    scrollButtons='auto'
                    visibleScrollbar={true}
                >
                    <NavbarCustomTab label='Dashboard' value={0} route={RouteConstants.home} />
                    <NavbarCustomTab label='Klienti' value={1} route={RouteConstants.clients} />
                    <NavbarCustomTab allowedRoles={[UserRole.User]} label='Události' value={2} route={RouteConstants.events} />
                    <NavbarCustomTab label='Atrakce a služby' value={3} route={RouteConstants.product} />
                    <NavbarCustomTab label='Brigádníci a dopravci' value={4} route={RouteConstants.workersAndCarriers} />
                    <NavbarCustomTab label='Statistiky' value={5} route={RouteConstants.statistics} />
                    <NavbarCustomTab label='Faktury' value={6} route={RouteConstants.invoices} />
                    <NavbarCustomTab label='Emaily a dotazníky' value={7} route={RouteConstants.emailsAndSurveys} />
                    <NavbarCustomTab label='Administrace' value={8} route={RouteConstants.administration} />
                </Tabs>
                <div
                    style={{ color: 'inherit', textDecoration: 'inherit' }}
                    onClick={() => handleNavigation(RouteConstants.settings)}
                >
                    <IconButton size='medium'>
                        <AccountCircleRoundedIcon />
                    </IconButton>
                </div>
            </Toolbar>
        </AppBar>
    )
}

export default Navbar
